import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CalendarEventEditPage from './CalendarEventEditPage';
import CalendarFeedsPage from './CalendarFeedsPage';
import CalendarFeedEditPage from './CalendarFeedEditPage';

/** Pages under /casa/eventos. */
const CalendarRoutes: React.FC = () => (
  <Routes>
    <Route path="novo" element={<CalendarEventEditPage />} />
    <Route path="calendarios" element={<CalendarFeedsPage />} />
    <Route path="calendarios/novo" element={<CalendarFeedEditPage />} />
    <Route path="calendarios/:feedId" element={<CalendarFeedEditPage />} />
    <Route path=":eventId" element={<CalendarEventEditPage />} />
  </Routes>
);

export default CalendarRoutes;
